import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useTheme } from "../../../../context/themeContext";
import useManageProjects from "../../../../hooks/useManageProjects";
import { setIsAppModalOpen } from "../../../../store/slices/profile/manageProjectsSlice";
import AppModal from "../../manage-project/tabs/hosted/app-modal";
import styles from "./style.module.css";
import axios from "axios";
import { node_server } from "../../../../constants";

const BasicLogo = () => {
	const { theme, darkMode } = useTheme();
	const [project, setProject] = useState([]);
	const { id } = useParams();
	const dispatch = useDispatch();
	const { fetchProjectApplicants } = useManageProjects();
	const [totalApplications, setTotalApplications] = useState();

	useEffect(() => {
		const fetchData = async () => {
			const response = await axios.get(
				`${node_server}/api/projects/info-with-total-applications/${id}`,
				{
					withCredentials: true,
				},
			);
			const data = response.data;
			const error = response.status !== 200 ? response.data : null;
			if (error) console.log(error);
			if (data) {
				setProject(data[0]);
				setTotalApplications(data[0].total_applications || 0);
			}
		};

		fetchData();
	}, []);

	const handleSeeApplicants = () => {
		dispatch(setIsAppModalOpen(true));
		fetchProjectApplicants(project);
	};

	return (
		<Box className={styles.basicLogo}>
			<AppModal
				project={project}
				setTotalApplications={setTotalApplications}
			/>
			<Box className={styles.content}>
				<Typography
					variant="body1"
					sx={{
						color: theme.palette.darkgrey.darkgrey600,
						fontSize: "20px",
						fontWeight: "500",
						textAlign: "center",
					}}
				>
					Edit Project Details
				</Typography>
			</Box>
			<Box className={styles.status}>
				<Box className={styles.container}>
					<Typography
						variant="body1"
						sx={{
							color: darkMode
								? theme.palette.darkgrey.darkgrey400
								: theme.palette.darkgrey.darkgrey600,
							fontSize: "14px",
							fontWeight: "500",
						}}
					>
						Number of Applicants
					</Typography>
					<Box className={styles.applicantNumber}>
						<Typography
							variant="body1"
							sx={{
								color: darkMode
									? theme.palette.darkgrey.darkgreybody50
									: theme.palette.darkgrey.darkgrey400,
								fontSize: "16px",
								fontWeight: "500",
								flex: "1 0 0",
							}}
						>
							{totalApplications}
						</Typography>
						<Typography
							variant="body1"
							onClick={handleSeeApplicants}
							sx={{
								color: darkMode
									? theme.palette.secondary.blue200
									: theme.palette.secondary.main,
								fontSize: "12px",
								fontWeight: "500",
								letterSpacing: "1px",
								textAlign: "center",
								cursor: "pointer",
							}}
						>
							View Applicants
						</Typography>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default BasicLogo;
